import React from 'react';
import classes from './Drawer.module.css';

const Drawer = ({ containerClass }) => {
    return (
        <div className={`${classes.drawer__container} ${containerClass}`}>
            <nav className={classes.drawer__links}>
                <a href='/#about_us'>About us</a>
                <a href='/#education'>Syllabus</a>
                <a href='/#whats_new'>What's New</a>
                <a href='https://docs.google.com/forms/d/e/1FAIpQLSeFmeKN3vE1yJxAGcliPhCWTySE7J6NU2jOjq4sCY5BCGMYlg/viewform?usp=sf_link' target='_blank' rel="noreferrer">Contact Us</a>
                <a href='/#hero'>TechStudyGroup</a>
                {/* {authState.isLoggedIn ? <a href='/home'>{'Hi, ' + authState.UserName}</a> : <a href='/#hero'>Login/Signup</a>} */}
            </nav>
            {/* <small className={classes.drawer__footnote}>
                &copy; <span>TechStudyGroup.</span> All rights reserved
            </small> */}    
        </div>
    );
};

export default Drawer;
